import {
    Component,
    OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'changelog',
    styleUrls: ['./styles.scss'],
    templateUrl: './tpl.pug'
})
export class ChangelogComponent implements OnInit {

    public localState: any;
    constructor(
        public route: ActivatedRoute
    ) { }

    public ngOnInit() {
        console.log('hello `changelog` component');
    }
}



// WEBPACK FOOTER //
// ./src/app/changelog/changelog.component.ts